export default __webpack_public_path__ + "static/media/p1.84c69b54.jpg";